import { Component, Injector, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BaseEntityComponent, BaseEntityConfig, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ROLE_AGENTE_ENVIO, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { CanComponentDeactivate } from "src/app/core/can-deactivate-guard.service";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { MOTIVO_CANCELAMENTO, SolicitacaoCancelamentoGarantia } from 'src/app/model/solicitacao-cancelamento-garantia.model';
import { OcorrenciaValidacaoVO } from "src/app/shared/ocorrencia-validacao.vo";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { SolicitacaoCancelamentoGarantiaService } from 'src/app/shared/services/solicitacao-cancelamento-garantia.service';



@Component({
    selector: 'app-cancelamento-cadastro',
    templateUrl: './cancelamento-cadastro.component.html',
    styleUrls: ['./cancelamento-cadastro.component.scss'],
    standalone: false
})
export class CancelamentoCadastroComponent extends BaseEntityComponent<SolicitacaoCancelamentoGarantia>
    implements OnInit, CanComponentDeactivate {


    public motivosCancelamento = MOTIVO_CANCELAMENTO;
    public agentesFinanceiros: AgenteFinanceiro[] = [];
    private ocorrencias: OcorrenciaValidacaoVO[] = [];
    public formularioValido: boolean;
    public solicitacoesForm: UntypedFormGroup = null;
    public cancelamentoPeloGestor: boolean;
    public solicitacaoCancelamento = new SolicitacaoCancelamentoGarantia();
    public sistemaSelecionado: string;
    public cnpjAgente: string;
    public modoEdicao: boolean = true;
    public podeEnviarSolicitacaoCancelamento: boolean;
    public usuarioAgenteFinanceiro: boolean;
    public cancelamentoCriadoComSucesso: boolean;

    constructor(
        protected injector: Injector,
        protected service: SolicitacaoCancelamentoGarantiaService,
        private bnUsuarioService: BnUsuarioService,
        private modalService: BnModalMessageService,
        private fb: UntypedFormBuilder,
        private permissaoService: PermissaoService,
        private activatedRoute: ActivatedRoute) {

        super(service, new BaseEntityConfig('/cancelamento/cadastro'));
        this.config.rotaLista = '/cancelamento/pesquisa';
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    }

    ngOnInit() {

        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.podeEnviarSolicitacaoCancelamento = resp && (resp[ROLE_AGENTE_ENVIO] || resp[ROLE_GESTOR_ENVIO]);
            this.cancelamentoPeloGestor = resp && resp[ROLE_GESTOR_ENVIO];
            const operacao = this.service.getOperacaoGarantida();

            this.preparaModelo().subscribe(model => {

                this.construirFormulario(model);
                
                if (operacao) {
                    this.config.rotaLista = `/operacoes/${operacao.id}`;
                    
                    model.cnpjAgenteFinanceiro = operacao.cnpjAgenteFinanceiro;
                    model.idOperacaoExterno = (operacao as any)?.ideExternoOperacao || null;
                    model.sistemaRepasse = (operacao as any)?.sistemaCobranca || null;
                    model.contratoRepasse = (operacao as any)?.contratoCobranca || null;
                    this.construirFormulario(model);
                    this.service.setOperacaoGarantida(null);
                    this.solicitacoesForm.disable();
                    this.solicitacoesForm.get('comentarioSolicitante').enable();
                    this.solicitacoesForm.get('valorPercentualMulta').enable();
                    
                    if(!model?.sistemaRepasse){
                        this.solicitacoesForm.get('idOperacaoExterno').disable();
                    }
                }
                else {
                    if(!this.cancelamentoPeloGestor) {
                        this.solicitacoesForm.get('cnpjAgenteFinanceiro').disable();
                        this.solicitacoesForm.get('ideMotivoSolicitacaoCancelamento').disable();
                    }
                }
                if(this.cancelamentoPeloGestor) {
                   this.solicitacoesForm.get('ideMotivoSolicitacaoCancelamento').enable();
                } 
            })
        },
            () => this.exibirErro('Usuário sem permissão para realizar esta ação')
        );

    }

    preparaModelo(): Observable<SolicitacaoCancelamentoGarantia> {
        return this.activatedRoute.params.pipe(
            switchMap(params => {
                const id = params["id"];

                if (id && !isNaN(id)) {
                    return this.service.getSolicitacaoCancelamento(id);
                }
                else {

                    const solicitacao = this.bnUsuarioService.usuario$.pipe(
                        switchMap(usuario => {
                            const model = this.service.getNewEntity();
                            model.cnpjAgenteFinanceiro = this.cancelamentoPeloGestor ? null : usuario.cnpj;
                            return of(model);
                        })
                    )

                    return solicitacao;
                }

            })
        );
    }

    construirFormulario(model: SolicitacaoCancelamentoGarantia): void {

        if (!this.solicitacoesForm) {
            this.solicitacoesForm = this.criarFormulario();
        }

        this.solicitacoesForm.patchValue({
            cnpjAgenteFinanceiro: model?.cnpjAgenteFinanceiro || null,
            idOperacaoExterno: model?.idOperacaoExterno || null,
            sistemaRepasse: model?.sistemaRepasse || null,
            contratoRepasse: model?.contratoRepasse || null,
            dataEnvio: model?.dataEnvio || null,
            dataAprovacao: model?.dataAprovacao || null,
            identificadorCobranca: model?.identificadorCobranca || null,
            estado: model?.estado || null,
            ideMotivoSolicitacaoCancelamento: model?.ideMotivoSolicitacaoCancelamento || null,
            comentarioSolicitante: model?.comentarioSolicitante || null,
            dataAprovacaoCancelamento: model?.dataAprovacaoCancelamento || null,
            usuarioEnvioCancelamento: model?.usuarioEnvioCancelamento || null,
            saldoFgiNaDataAprovacaoCancelamento: model?.saldoFgiNaDataAprovacaoCancelamento || null,
            valorPercentualMulta: model?.valorPercentualMulta || null,
            historicoEstados: model?.historicoEstados || null,
        });
    }

    criarFormulario(): UntypedFormGroup {
        const form = this.fb.group({
            cnpjAgenteFinanceiro: null,
            idOperacaoExterno: null,
            sistemaRepasse: null,
            contratoRepasse: null,
            dataEnvio: [{
                value: null,
                disabled: true
            }],
            dataAprovacao: null,
            identificadorCobranca: null,
            estado: null,
            ideMotivoSolicitacaoCancelamento: null,
            comentarioSolicitante: [null, [Validators.required, Validators.minLength(10)]],
            dataAprovacaoCancelamento: null,
            usuarioEnvioCancelamento: [{
                value: null,
                disabled: true
            }],
            saldoFgiNaDataAprovacaoCancelamento: null,
            valorPercentualMulta: null,
            historicoEstados: null,
        });

        form.get('sistemaRepasse').valueChanges.subscribe(sistema => {
            const contratoRepasse = form.get('contratoRepasse');
            const idOperacaoExterno = form.get('idOperacaoExterno');
                
            console.log(sistema)
            if (sistema && sistema !== 'null') { 
                console.log("tem sistema");
                contratoRepasse.setValidators([Validators.pattern(/^[0-9]+$/),
                Validators.minLength(11), Validators.maxLength(11), Validators.required]);
                idOperacaoExterno.disable();
                idOperacaoExterno.clearValidators();
                idOperacaoExterno.setValue(null);
                contratoRepasse.enable();
               
            } else {
                idOperacaoExterno.enable()
                idOperacaoExterno.setValidators([Validators.pattern(/^[A-Za-z0-9_\-]+$/),
                    Validators.minLength(1), Validators.maxLength(20), Validators.required]);
                contratoRepasse.disable();
                contratoRepasse.clearValidators();
                contratoRepasse.setValue(null);
                idOperacaoExterno.enable();
            }

            idOperacaoExterno.clearValidators();           
            
            contratoRepasse.updateValueAndValidity();
            idOperacaoExterno.updateValueAndValidity();
        });

        return form;
    }


    getParams(): SolicitacaoCancelamentoGarantia {
        const params: SolicitacaoCancelamentoGarantia = this.solicitacoesForm.getRawValue();
        return params;
    }

    salvar() {
        this.cancelamentoCriadoComSucesso = false;

        this.abreModalConfirmacao('Deseja realmente enviar esta solicitação de cancelamento?')
            .then(resp => {
                if (resp === true) {
                    this.service.salvarSolicitacaoCancelamento(this.getParams(), false)
                        .subscribe(model => {
                            this.construirFormulario(model);
                            this.exibeMensagemSucesso();
                            this.cancelamentoCriadoComSucesso = true;
                            console.log("tentando navegar para " + '/cancelamento/cadastro/' + model.id);
                            this.router.navigate([`/cancelamento/cadastro/${model.id}`]);

                        }, error => {
                            console.log(error);
                            this.ocorrencias = this.service.ocorrencias;
                        });
                }
            });
    }

    exibeMensagemSucesso(): void {
        this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Solicitação de cancelamento enviada com sucesso.'
        });
    }

    exibirErro(erro: string) {
        this.messageService.addMessage({
            title: 'Erro',
            type: 'CRUD_OPERATION',
            level: messageLevel.ERROR,
            message: erro
        });
    }

    async abreModalConfirmacao(mensagem: string): Promise<boolean> {
        const titulo = 'Confirmação';

        try {
            const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
            return resultadoConfimacao.value === 'ok';
        } catch (e) {
            return false;
        }
    }

    canDeactivate(): Promise<boolean> | boolean {
        console.log("ta pristine: " + this.solicitacoesForm.pristine);

        if (this.cancelamentoCriadoComSucesso || this.ocorrencias.length > 0 || this.solicitacoesForm.pristine || !this.modoEdicao)
            return true;

        return this.abreModalConfirmacao('Deseja descartar esta Solicitação de Cancelamento ?');
    }

}